import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const IssueTemporarySvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.51093 21.0763H19.4891C21.0556 21.0763 22 19.9815 22 18.5843C22 18.1434 21.8731 17.678 21.6286 17.2501L14.1368 4.16474C13.6604 3.33592 12.84 2.92358 12.0019 2.92358C11.16 2.92358 10.3312 3.33592 9.8632 4.16474L2.37138 17.2501C2.11845 17.6864 2 18.1434 2 18.5843C2 19.9815 2.94435 21.0763 4.51093 21.0763ZM4.52314 19.743C3.79908 19.743 3.36621 19.1934 3.36621 18.5805C3.36621 18.3648 3.42184 18.1124 3.54151 17.8928L11.0211 4.80653C11.2348 4.43185 11.6226 4.26914 12.0019 4.26914C12.369 4.26914 12.7483 4.43185 12.9704 4.80653L20.45 17.9012C20.5697 18.1208 20.6253 18.3648 20.6253 18.5805C20.6253 19.1934 20.1925 19.743 19.4684 19.743H4.52314ZM11.9981 14.6592C12.4016 14.6592 12.642 14.4197 12.6504 13.9672L12.779 8.8794C12.7874 8.44382 12.4421 8.11535 11.9897 8.11535C11.5204 8.11535 11.2003 8.43539 11.2088 8.87096L11.3205 13.9672C11.3289 14.4113 11.5693 14.6592 11.9981 14.6592ZM11.9981 17.699C12.5175 17.699 12.9514 17.2876 12.9514 16.7711C12.9514 16.247 12.526 15.8431 11.9981 15.8431C11.474 15.8431 11.0364 16.2554 11.0364 16.7711C11.0364 17.2791 11.4825 17.699 11.9981 17.699Z"
        fill={color}
      />
    </svg>
  );
};

export { IssueTemporarySvg };
